import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorApi } from "./lib/api";
import { router } from "./router";
import { ProveedorSesion } from "./sesion";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Nunca reintentar un 4xx: si la API dijo que los datos están mal, o
      // que no hay permiso, insistir no cambia nada.
      retry: (intentos, error) =>
        error instanceof ErrorApi && error.status < 500 ? false : intentos < 2,
    },
    mutations: {
      // Las mutaciones NO se reintentan solas. Timbrar cuesta dinero y es
      // irreversible: el reintento siempre lo decide una persona.
      retry: false,
    },
  },
});

const raiz = document.getElementById("root");
if (!raiz) throw new Error("Falta el div #root");

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProveedorSesion>
        <RouterProvider router={router} />
      </ProveedorSesion>
    </QueryClientProvider>
  </StrictMode>,
);
